export default __webpack_public_path__ + "static/media/Leggings of Swiftstriking.1572f9d6.jpg";